import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Button, CircularProgress, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams,useSearchParams } from "react-router";
import UserPersonalInformation from "./userPersonalInformation";
import TransactionsRecord from "./transactionsRecord";
import ListCreditsStore from "./listCreditsStore";
import TransactionGiftCharge from "./transactionGiftCharge";
import UserLoans from "./userLoans";
import { useQuery } from "@tanstack/react-query";
import { fetchDetailClubUsers } from "@/api/merchant/request.get";
import CardKit from "@/shared/components/kit/card";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { UserInfoClub } from "@/types/api/merchant/merchant.type";
import AlertDialog from "@/shared/components/kit/modal";
import AddUser from "./addUserToCompany";
import AddSinglUser from "./addSinglUser";
import AddGroupUser from "./addGroups";
import BoxKit from "@/shared/components/kit/box";

const Content = () => {
  const navigate = useNavigate();
  
  const [isOpenModalAddUser, setIsOpenModalAddUser] = useState(false);
  const [selectedOption, setSelectedOption] = useState<string>("option1");
  const [isOpenModalAddUserSingle, setIsOpenModalAddUserSingle] = useState(false);
  const [isOpenModalAddUserSingleGroup, setIsOpenModalAddUserSingleGroup] = useState(false);
  const [isOpenModalAddUserGroup, setIsOpenModalAddUserGroup] = useState(false);
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const { data, isLoading } = useQuery({
    queryKey: ["listClubs-data", id],
    queryFn: () => fetchDetailClubUsers(id),
  });

  const [clubList, setClubList] = useState<UserInfoClub[]>([]);

  useEffect(() => {
    if (data?.club) setClubList(data.club);
  }, [data]);

  const handleControllModalSingle = () => {
    setIsOpenModalAddUser(false);
    if (selectedOption === "option1") setIsOpenModalAddUserSingle(true);
    else setIsOpenModalAddUserSingleGroup(true);
  };

  const handleDelete = (id: number) => {
    setClubList((prev) => prev.filter((item) => item.id !== id));
  };
  const page = searchParams.get("page");
  const club = searchParams.get("club");
  return (
    <StackKit  alignItems="start" gap={2}>
      <StackKit direction={'row'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
        <TypoGraphyKit variant="h6">جزئیات کاربر</TypoGraphyKit>
        <Button variant="contained" size="small" onClick={() => navigate(`/customer-my-organization/${club}?page=${page ? page : 1}`)} sx={{ minWidth: '80px' }}>
          بازگشت
        </Button>
      </StackKit>
      {/* User Info & Records */}
      <div className="flex flex-col md:flex-row gap-4 w-full">
        <div className="w-full md:w-5/12 relative">
          {isLoading ? 
            <div style={{position: 'absolute',top: 0,left: 0,right: 0,bottom: 0,backgroundColor: 'rgba(0, 0, 0, 0.5)',display: 'flex',justifyContent: 'center',alignItems: 'center',zIndex: 1000,borderRadius: '8px'}}>
                <CircularProgress sx={{ color: '#fff' }} />
            </div>
          :
            <UserPersonalInformation dataUser={data?.user_info} />
          }
        </div>
        <div className="w-full md:w-7/12 flex flex-col gap-4">
          <TransactionsRecord />
          <ListCreditsStore />
          <TransactionGiftCharge dataUser={data?.last_transaction} />
          <UserLoans />
        </div>
      </div>

      {/* Club Cards */}
      <div className="flex flex-wrap gap-4 justify-center md:justify-end w-full">
        {/* Add User Modals */}
        <AlertDialog disagreeText="بستن" agreeText="ادامه" isHeader open={isOpenModalAddUser} onClose={() => setIsOpenModalAddUser(false)} onAgree={handleControllModalSingle} onDisagree={() => setIsOpenModalAddUser(false)}
          header={<TypoGraphyKit variant="h6">افزودن کاربر</TypoGraphyKit>}
        >
          <AddUser selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
        </AlertDialog>

        <AlertDialog disagreeText="بستن" agreeText="ادامه" isHeader open={isOpenModalAddUserSingle} onClose={() => setIsOpenModalAddUserSingle(false)} onDisagree={() => setIsOpenModalAddUserSingle(false)}
          header={<TypoGraphyKit variant="h6">افزودن انفرادی کاربر</TypoGraphyKit>}
        >
          <AddSinglUser selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
        </AlertDialog>

        <AlertDialog disagreeText="بستن" agreeText="ادامه" isHeader open={isOpenModalAddUserGroup} onClose={() => setIsOpenModalAddUserGroup(false)} onDisagree={() => setIsOpenModalAddUserGroup(false)}
          header={<TypoGraphyKit variant="h6">افزودن گروهی کاربر</TypoGraphyKit>}
        >
          <AddGroupUser selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
        </AlertDialog>

        {/* Club Cards */}
        {clubList?.map((item) => (
          <BoxKit>
            <CardKit key={item.id} sx={{ bgcolor: "#2C2C2C", paddingTop: "10px", position: "relative", }} className="w-full sm:w-[calc(50%-8px)] md:w-[265px]">
              <IconButton onClick={() => handleDelete(item.id)} sx={{ position: "absolute", top: 8, right: 8, color: "#fff", backgroundColor: "#eb6440", "&:hover": { backgroundColor: "#d50000" }, zIndex: 1, }}>
                <DeleteOutlinedIcon />
              </IconButton>

              <StackKit justifyContent="center" alignItems="center" gap={1}>
                <div className="bg-[#A1A1A1] rounded-lg p-5 w-full h-[229px] flex justify-center items-center overflow-hidden">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
                </div>

                <div className="flex justify-between w-full text-white">
                  <div>تعداد کاربران: {item.count} نفر</div>
                  <GroupOutlinedIcon style={{ color: "#fff" }} />
                </div>
                <div className="flex justify-between w-full text-white">
                  <div>{item.title}</div>
                </div>
              </StackKit>
            </CardKit>
          </BoxKit>
        ))}
      </div>
    </StackKit>
  );
};

export default Content;
